import { AlphaUCircleIcon } from './AlphaUCircleIcon';

/**
 * author: Contributors
 * id C47AD771-D938-41ED-B07A-28499959E3BF
 * name alpha-u-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-u-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterUCircleIcon = AlphaUCircleIcon;
export default LetterUCircleIcon